// QA environment. Auth0 tenant, exchange (VAST), and EPG endpoints are shared with dev for now
// (no dedicated QA Auth0 tenant/exchange has been provisioned) — only serviceUrl is QA-specific.
//
// `production` is deliberately kept false, not just copied from dev by accident: main.ts only
// calls enableProdMode() when this is true, but the same flag is ALSO read directly (inline
// ternaries, not this file) in creative-designer-dialog.component.ts,
// creative-designer-variants-preview-dialog.component.ts, and creative-studio.service.ts to
// choose between the real production Moments service (moments.videobyte.com) and the shared dev
// one (moments.dev.dh.videobyte.tech). Flipping this to true would silently point QA's video
// preview traffic at the real prod Moments service. Don't flip it without first decoupling those
// call sites onto their own environment-specific flag/URL.
export const environment = {
  production: false,
  serviceUrl: 'https://api-qa-dx.revyrie.co',
  vastUrl: 'https://dev-x.videobyte.com',
  epgGenresService: 'https://dev-epg.videobyte.com/main/api/genre',
  epgKeywordsService: 'https://dev-epg.videobyte.com/main/api/keyword',
  auth0: {
    domain: 'dev-xkh41bk6wz51mic6.us.auth0.com',
    clientId: 'yvhEqGTh0pLHzY2OtRcAYXWZdq3yf4et',
    audience: 'https://api.dxkulture.com',
  },
  aiInsightsMock: false,
};
